interface SpaceProps {
  height: number
}

const Space: React.FC<SpaceProps> = ({ height }) => {
  return <div style={{ width: '100%', height: height }} />
}

export default Space
